import { data } from '../../svg/Product/data';
import { makeIcon } from '../makeIcon';

export const Product = makeIcon(data, 'product', 'Product');

export default Product;
